import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import ConfirmationPagePlanCard from '@/components/ConfirmationPagePlanCard';
import PSText from '@/components/ui/PSText';
import type { Membership } from '@/src/api/membershipsApi';
import {
  ACCESS_PASS_PLAN,
  LONG_COPY_PLAN,
  TRIAL_PLAN,
} from '@/src/lib/membershipFixtures';

const PREVIEWS: { id: string; label: string; plan: Membership }[] = [
  { id: 'trial', label: 'trial — pink glow, TRIAL badge', plan: TRIAL_PLAN },
  {
    id: 'access-pass',
    label: 'access_pass — wine glow',
    plan: ACCESS_PASS_PLAN,
  },
  {
    id: 'long',
    label: 'long description — wraps, card grows',
    plan: LONG_COPY_PLAN,
  },
];

export default function ConfirmationPagePlanCardPreview() {
  return (
    <>
      <Head>
        <title>ConfirmationPagePlanCard · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack gap="$xl" p="$lg">
          {PREVIEWS.map((preview) => (
            <YStack key={preview.id} gap="$sm">
              <PSText.Body3 color="$textDarkMuted">
                {preview.label}
              </PSText.Body3>
              <ConfirmationPagePlanCard plan={preview.plan} />
            </YStack>
          ))}
        </YStack>
      </ScrollView>
    </>
  );
}
